import React from 'react';
import checkmark from "url:../../assets/icons/checkmark.svg";

interface Props {
    checked: boolean;
}

const CheckBox: React.FC<Props> = (props: Props) => {

    return (
        <div className={"z-checkbox cursor-pointer" + (props.checked ? " checked" : "")}>
          {props.checked && <img src={checkmark} alt="checked" />}
        </div>
    );
};

export default CheckBox;
